import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { TprecmService } from '../../tprecm.service';
import { ColumnDef, PageOptions } from '../../../../shared/data-table/data-table.interface';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ProgramToolFrontLoaderComponent } from './program-tool-front-loader/program-tool-front-loader.component';
import { AddProgramModalComponent } from './add-program-modal/add-program-modal.component';
import { ProgramMaintenanceService } from './program-maintenance.service';
import { LazyLoadEvent } from 'primeng/api/primeng-api';
import { finalize } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Engineer } from 'src/modules/api/tprecm-api.interface';
import { TprecmApiService } from 'src/modules/api';

@Component({
   selector: 'program-maintenance',
   templateUrl: './program-maintenance.component.html',
   styleUrls: ['./program-maintenance.component.css']
})
export class ProgramMaintenanceComponent implements OnInit {

   pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('programName');

   selectedProgram;
   programs: any[];
   loading = false;
   tableSize = 10;
   total = 0;
   first = 0;
   programMse$ = new BehaviorSubject<Engineer[]>([]);
   engineers$ = new BehaviorSubject<Engineer[]>([]);
   searchBarInput: any;
   programNameFilter: any;


   columns: ColumnDef[] = [
      { field: 'programName', name: 'Program Name', editable: false },
      { field: 'modelYear', name: 'Model Year', editable: false, width: '6em' },
      { field: 'style', name: 'Style', editable: false, width: '6em' },
      {
         field: 'manager1Id', name: 'MFD EGM', type: 'dropdown', width: '16em',
         optionsList: this.programMse$, optionsListField: 'id', optionsListName: 'lastFirstName', visible: false
      },
      {
         field: 'engineer1Id', name: 'MFD Engineer', type: 'dropdown', width: '16em',
         optionsList: this.engineers$, optionsListField: 'id', optionsListName: 'lastFirstName', visible: false
      },
      { field: 'manager2Id', name: 'EGM', type: 'dropdown', width: '14em', optionsList: this.programMse$, optionsListField: 'id', optionsListName: 'lastFirstName' },
      { field: 'engineer2Id', name: 'Engineer', type: 'dropdown', width: '14em', optionsList: this.engineers$, optionsListField: 'id', optionsListName: 'lastFirstName' },
      { field: 'newProgram', name: 'New Program?', width: '5em', type: 'checkbox', tooltip: 'Check box if this is a new program.' },
      { field: 'ecm', name: 'Used by ECM?', width: '5em', type: 'checkbox', tooltip: 'Check box if this program is used by ECM.' },
      { field: 'sop', name: 'SOP Date', width: '6em', type: 'date', tooltip: 'SOP Date' },
      { field: 'fe31', name: 'CVER or A1R Date', width: '6em', type: 'date', tooltip: 'CVER or A1R Date' },
      { field: 'fe32', name: 'SVER or A2R Date', width: '6em', type: 'date', tooltip: 'SVER or A2R Date' },
      { field: 'fe33', name: 'IVER or Beta Date', width: '6em', type: 'date', tooltip: 'IVER or Beta Date' },
      { field: 'bodyShopTest', name: 'Body Shop Test Date', width: '6em', type: 'date', tooltip: 'Body Shop Test Date' },
      { field: 'hemPass2', name: 'Hem Pass 1 Date', width: '6em', type: 'date', tooltip: 'Hem Pass 1 Date' },
      { field: 'active', name: 'Active?', type: 'checkbox', width: '5em', tooltip: 'Check box if program is active.' },
      { field: 'endOfProduction', name: 'End Of Production', width: '6em', type: 'date', tooltip: 'End of Production Date' },
      { field: 'noLitigationHold', name: 'No Litigation Hold?', type: 'checkbox', width: '5em', tooltip: 'Check box if program had Litigation Hold.' }
   ];

   constructor(
      private readonly dialog: MatDialog,
      private readonly dialogRef: MatDialogRef<ProgramMaintenanceComponent>,
      private readonly tprEcmService: TprecmService,
      private readonly tprEcmApiService: TprecmApiService,
      private readonly programMaintenanceService: ProgramMaintenanceService,
      private readonly toastr: ToastrService,
      private readonly dataTableService: DataTableService
   ) {
      this.tableSize = this.tprEcmService.gridSize;
   }

   get hasValidToolFrontLoaderProgramSelected(): boolean {
      return this.selectedProgram && !!this.selectedProgram.sop;
   }

   ngOnInit() {
      this.loadLookupValues();
   }

   loadLookupValues() {
      this.tprEcmApiService.getEngineers()
         .subscribe(res => {
            if (res) { this.engineers$.next(res); }
         });
      this.tprEcmApiService.getProgramMSE()
         .subscribe(res => {
            if (res) { this.programMse$.next(res); }
         });
   }

   loadPrograms() {
      this.loading = true;
      this.programMaintenanceService.getPrograms(this.programNameFilter, this.pageOptions)
         .pipe(finalize(() => this.loading = false))
         .subscribe(res => {
            if (res && res.data) {
               this.programs = res.data;
               this.total = res.totalCount;
            }
         });
   }

   onToolFrontLoaderClick() {
      if (!this.selectedProgram) {
         this.toastr.error('You must select a row before you click the Tool Front Loader button');
         return;
      }

      if (!this.selectedProgram.sop) {
         this.toastr.error('You must select an SOP date for this program before selecting the Tool Front Loader button');
         return;
      }

      this.dialog.open(ProgramToolFrontLoaderComponent,
         {
            autoFocus: true,
            disableClose: true,
            data: this.selectedProgram
         });
   }

   onAddProgramClick() {
      this.dialog.open(AddProgramModalComponent,
         {
            autoFocus: true,
            disableClose: true,
            data: this.selectedProgram
         }).afterClosed().subscribe(res => (res && res.reload) ? this.refreshAddedProgram() : '');
   }

   refreshAddedProgram() {
      this.pageOptions.sort = 'id';
      this.pageOptions.order = 'desc';
      this.loadPrograms();
   }

   refreshPrograms() {
      this.pageOptions.sort = 'programName';
      this.pageOptions.order = 'asc';
      this.loadPrograms();
   }

   onLazyLoad(event: LazyLoadEvent) {
      this.selectedProgram = null;

      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      const sortNameIdx = event.sortField.toLowerCase().lastIndexOf('id');
      const sortName = event.sortField.slice(0, (sortNameIdx === -1) ? event.sortField.length : sortNameIdx);
      this.pageOptions.sort = sortName || this.pageOptions.sort;
      this.pageOptions.size = event.rows || this.pageOptions.size;
      this.pageOptions.page = (event.rows) ? event.first / event.rows : this.pageOptions.page;
      this.tprEcmService.gridSize = event.rows;
      this.loadPrograms();
   }

   updateSelectedProgram(dataItem) {
      this.selectedProgram = dataItem;
   }

   updateProgram(dataItem) {
      // Don't update if Active is set without a valid SOP Date
      if (dataItem && (!dataItem.data.active || dataItem.data.sop)) {
         this.programMaintenanceService.updateProgram(dataItem.data)
            .subscribe();
      }
   }

   searchByProgram(event: any) {
      this.programNameFilter = event.value;
      this.refreshPrograms();
   }

   clearSearch() {
      this.searchBarInput = '';
      this.programNameFilter = '';
      this.refreshPrograms();
   }


   close() {
      const activeSops = this.programs
         .filter(program => program.active)
         .every(program => program.sop);

      if (!activeSops) {
         this.toastr.error('One or more Active Programs is missing an SOP Date. Fill in all missing SOP Dates before Closing the Programs window.');
         return;
      }

      this.dialogRef.close();
   }
}
